import { ModelRow } from "@mcleod/core";
import { DataSource, DataSourceMode } from "../../databinding/DataSource";
import { UnitInputField } from "./UnitInputField";
import { Textbox } from "../textbox/Textbox";
import { TextboxProps } from "../textbox/TextboxProps";

export class UnitInputFieldInnerTextbox extends Textbox {
    protected unitInputField: UnitInputField;

    constructor(props: Partial<TextboxProps>, unitInputField: UnitInputField) {
        super({
            ...props,
            allowContextMenu: false,
            allowTooltip: false,
            captionVisible: false,
            margin: 0,
            padding: 0,
            style: {
                // Defeat hard-coded default textbox width from TextboxStyles.base
                width: "unset"
            }
        });
        this.unitInputField = unitInputField;
        this.addFocusListener(this.updateBordersForFocus);
        this.addBlurListener(this.updateBordersForBlur);
    }

    private updateBordersForFocus = () => {
        this.unitInputField.updateBordersForFocus(true);
    }

    private updateBordersForBlur = () => {
        this.unitInputField.updateBordersForFocus(false);
    }

    override get dataSource(): DataSource {
        return super.dataSource;
    }

    // Override 'set dataSource()' to avoid adding the textbox to the dataSource's bound components
    override set dataSource(value: DataSource) {
        super.dataSource = value;
        value.removeBoundComponent(this);
    }

    override get field(): string {
        return super.field;
    }

    // Override 'set field()' to avoid calling updateComponentsByField()
    override set field(value: string) {
        super.field = value;
        this.dataSource?._removeFromComponentsByField(this, value);
    }

    get validationWarning(): string {
        // Defeat validationWarning logic in Textbox
        return null;
    }

    set validationWarning(_value: string) {
        // Defeat validationWarning logic in Textbox
    }

    // Override so that the overall UnitInputField component is validated, instead of validating either individual
    // inner textbox
    override checkForValidationSuccess(blurring: boolean): void {
        if (this.validationWarning != null || blurring)
            this.unitInputField.validate(true);
    }

    // Override so that updating the inner textbox's text refreshes the UnitInputField component's printable label
    protected override syncPrintableLabelText() {
        this.unitInputField.syncPrintableLabelText();
    }

    // Override to delegate update of bound data to the enclosing UnitInputField
    public override updateBoundData(row: ModelRow, mode: DataSourceMode) {
        this.unitInputField.updateBoundData(row, mode);
    }
}
